/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:03]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faUsersBetweenLines } from '@fortawesome/free-solid-svg-icons';
import { resetRoleCache } from 'axios/roleApi';
import useApi from 'hooks/useApi';
import { useMutation } from 'react-query';

const RoleResetCacheButton = () => {
    const api = useApi();

    const resetRoleCacheMutation = useMutation('resetRoleCache', () => resetRoleCache(api));

    return (
        <DropdownFilterButton
            onClick={() => {
                resetRoleCacheMutation.mutate();
            }}
            icon={faUsersBetweenLines}
            disabled={resetRoleCacheMutation.isLoading}
            title="BackOfficeResetRoleCache"
        />
    );
};

export default RoleResetCacheButton;
